import React from 'react';
import { Link } from 'react-router-dom';
import './Shared-Formatting.css';

function Article() {
  return (
    <div className="article-wrapper">
      <article className="article-container">
        <h1 className="article-title">The Missing Mechanisms of Mech Interp</h1>
        <div className="article-meta">
          <span>Published on: July 7th, 2025</span> | <span>Author: Isaiah Milbank</span>
        </div>
        <div className="article-content">
          <h2>Or: My thoughts on the direction of progress for Mechanistic Interpretability research</h2>
	  <p>My view of interpretability research is that it can be split into two seperate but related challenges:
	  <ul> 
	  <li>Identifying representations</li>
	  <li>Identifying consistent, persistent transformations</li>
	  </ul>
	  </p>
	  <p>Some of the characteristics that I care about for representations are that they are meaningful and faithful. A meaningful representation maps to some piece of useful information, and a faithful representation is built and used as if it were the concept it represents. </p> 
	  <p>Some of the characteristics that I care about for transformations are that they are consistent and generalizable. A consistent transformation is one that transforms the same inputs into the same outputs(within some epsilon, we're not animals). A generalizable transformation can have its inputs and outputs defined in terms of well-defined patterns(well-defined to be weller-defined at a later date)</p>
	  <p>I believe that there should be a weakening of our inductive bias on feature searching, and an increased focus on more granular mechanisms. It seems like much of the bleeding edge interpretability—here meaning the Anthropic Biology of a Language Model papers—uses component level granularity, identifying circuits by the query, key, and value heads, or sometimes only the head itself. </p>
	  <p>
	  There may be some promising updates on sub-component mechanisms with the recent Stochastic Parameter Decomposition paper, though I reserve the right to withhold judgement until after I have finished reading it. When I do, my notes will be available in the <Link to="/papers">paper-notes</Link> section.
	  </p>

	  <h2>Representations and Transformations are symbiotic</h2>
          <p>I make two symmetric claims:</p>
	  <ul>
	  <li>Good representations can assist in identifying good transformations</li>
	  <li>Good transformations can assist in identifying good representations</li>
	  </ul>
	  <p>The first claim is almost readily apparent. Consider the following ways you could use a good representation: </p>
	  <ul>
	  <li>Determine the component which creates a representation by checking its instantiation at each layer</li>
	  <li>Isolate a component's behavior on groups of input and output representations. Then, you can look directly at the weights of the representations, and view how they are directly transformed by the component. </li>
	  <li>One of the big issues of interpetability is the question of "Does this modification change the behavior of the model," which affects the usability of methods like zero and mean ablation. With a good understanding of information representation, you could identify exactly what the remainder of the residual stream information represents</li>
	  </ul>

	  <h2>Existing techniques in this framework</h2>
	  <h3>SAEs</h3>
	  <p>SAEs are primarily a representational tool. </p>
        </div>
        <footer className="article-footer">
          <p>Thanks for reading! Check out more articles in the <Link to="/articles">Articles</Link> section.</p>
        </footer>
      </article>
    </div>
  );
}

export default Article;
